import type { SectionNavigationSidebarProps } from "./SectionNavigationDialog.types";
import SectionNavigationItem from "./SectionNavigationItem";

const SectionNavigationSidebar = ({
  sections,
  activeSection,
  onNavigate,
}: SectionNavigationSidebarProps) => {
  return (
    <nav className="w-64 border-r border-gray-100 bg-gray-50 overflow-y-auto px-2 py-4 rounded-bl-lg">
      <div className="space-y-2">
        {sections.map((section, index) => (
          <SectionNavigationItem
            key={section.id}
            section={section}
            isActive={activeSection === section.id}
            activeSection={activeSection}
            isLastSection={index === sections.length - 1}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </nav>
  );
};

export default SectionNavigationSidebar;
